import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { loadTrustPilotElement } from 'utils/thirdParties';

import './Trustpilot.scss';

// This component is duplicated in dotCMS as a widget to be used in the editor
const Trustpilot = ({ isPopup, omitBorder = false, theme = 'light' }) => {
  const widget = useRef(null);
  useEffect(() => {
    if (widget) {
      loadTrustPilotElement(widget.current);
    }
  }, []);

  let dataTemplateId = '5419b6ffb0d04a076446a9af';
  if (isPopup) {
    dataTemplateId = '5418052cfbfb950d88702476';
  }

  return (
    <section className={cx('Trustpilot', omitBorder && 'omitBorder')} id="trustpilot-widget">
      <div className="TrustpilotWrapper">
        <div
          ref={widget}
          className={cx('trustpilot-widget', 'TrustpilotWidget')}
          data-locale="en-US"
          data-template-id={dataTemplateId}
          data-businessunit-id="5c0d6caf5a7b380001a9fb98"
          data-style-height={isPopup ? '30px' : '24px'}
          data-style-width="100%"
          data-theme={theme}
        />
      </div>
    </section>
  );
};

export default Trustpilot;
